var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"idziknG-JPCK7dn1doKl_"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { afterPageLoad } from "./utils/afterPageLoad";

// The SDK is loaded and initialized after the page has loaded (afterPageLoad), not
// bundled into every page's initial JavaScript (it was ~40 KB gzipped of pages/_app,
// and delayed LCP). Errors thrown before it initializes are not reported.
function initSentry() {
  import("@sentry/nextjs").then((Sentry) => {
    Sentry.init({
      dsn: "https://6392754b1a5b6e16d59fe0baab57276b@o4506425710018560.ingest.us.sentry.io/4508175639969792",

      // Add optional integrations for additional features
      integrations: [],

      // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
      tracesSampleRate: 0.03,

      // Define how likely Replay events are sampled.
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.1,

      // Define how likely Replay events are sampled when an error occurs.
      replaysOnErrorSampleRate: 1.0,

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,
    });
  });
}

if (typeof window !== "undefined") afterPageLoad(initSentry);
